import { useCallback, useEffect, useState } from 'react'
import client from 'services/client'
import { BaseDataContent } from 'types/base.type'
import { SocioeducationHistoryType } from 'types/socioeducation-history.type'
import { usePagination } from 'hooks/pagination.hook'

export const useMeioAbertoHistorico = (id?: string) => {
  const [isLoading, setLoading] = useState<boolean>(false)
  const {
    page,
    rows: { rowsPerPage, rowsOptions },
    elements: { totalOfElements, handleTotalOfElements },
    pages: { handleTotalOfPages, totalOfPages },
    handleRowsPerPage,
    handleNewPage,
  } = usePagination()

  const [historico, setHistorico] = useState<SocioeducationHistoryType[] | null>(null)

  const handleBuscar = useCallback(async () => {
    setLoading(true)
    if (id) {
      const url = `/meio-aberto/${id}/historico`
      await client
        .get<BaseDataContent<SocioeducationHistoryType[]>>(url, {
          page: page,
          pageSize: rowsPerPage,
        })
        .then((response) => {
          if (response.data && response.data.content) {
            handleTotalOfPages(response.data.totalPages)
            handleTotalOfElements(response.data.totalElements)
            setHistorico(response.data.content)
          }
        })
    }
    setLoading(false)
  }, [id, page, rowsPerPage])

  useEffect(() => {
    handleBuscar()
  }, [handleBuscar])

  return {
    historico,
    handleBuscar,
    isLoading,

    page,
    rowsPerPage,
    rowsOptions,
    totalOfElements,
    handleNewPage,
    handleRowsPerPage,
    totalOfPages,
  }
}
